import * as moment from "moment";

import { Location } from "redux-little-router";

export interface SraCustomerListModel {
    readonly id: string;
    readonly name?: string;
    readonly listUpdated?: moment.Moment;
}

export interface SraCustomerDetailModel {
    readonly id: string;
    readonly name?: string;
    readonly prefix?: string;
    readonly emailAddress?: string;
    readonly phoneNumber?: string;
    readonly detailUpdated?: moment.Moment;
    readonly active?: boolean;
}

export type SraCustomer = SraCustomerListModel & SraCustomerDetailModel;

export interface SraCustomerCreateModel {
    id: string;
    name: string;
    prefix: string;
    emailAddress: string;
    phoneNumber: string;
}

export interface SraCustomerEditModel {
    id: string;
    name: string;
    prefix: string;
    emailAddress: string;
    phoneNumber: string;
}

export interface SraCustomerState {
    readonly sraCustomers: SraCustomer[];
    readonly sraCustomer?: SraCustomer;
}

export interface SraCustomerFilter {
}

export class SraCustomerBuilder {
    private id: string;
    private name: string;
    private prefix: string;
    private emailAddress: string;
    private phoneNumber: string;

    constructor() {
        this.name = "Test 1";
        this.prefix = "Test 1";
        this.emailAddress = "Test 1";
        this.phoneNumber = "Test 1";
    }

    public withId(id: string): SraCustomerBuilder {
        this.id = id;
        return this;
    }

    public withname(name: string): SraCustomerBuilder {
        this.name = name;
        return this;
    }

    public withprefix(prefix: string): SraCustomerBuilder {
        this.prefix = prefix;
        return this;
    }

    public withemailAddress(emailAddress: string): SraCustomerBuilder {
        this.emailAddress = emailAddress;
        return this;
    }

    public withphoneNumber(phoneNumber: string): SraCustomerBuilder {
        this.phoneNumber = phoneNumber;
        return this;
    }

    public build(): SraCustomerEditModel {
        return {
            id: this.id,
            name: this.name,
            prefix: this.prefix,
            emailAddress: this.emailAddress,
            phoneNumber: this.phoneNumber,
        };
    }

}

export type AppState = SraCustomerState & { router: Location };
